export const getInvite = ({ orgs }) => orgs.invite;
export const getCurrOrg = ({ orgs }) => orgs.currOrg;
export const getSwitchOrgPending = ({ orgs }) => orgs.switchOrgPending;
export const getOrgDetails = ({ orgs }) => orgs.orgDetails;
